module.exports = __webpack_public_path__ + "static/img/loginPic.376414e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/loginPic.png
// module id = 8r4y
// module chunks = 2